<div class="header">
  <h1 mat-dialog-title DraggableDialog>{{ data.title }}</h1>
</div>
<div class="flex-container">
  <mat-dialog-content>
    <p [innerHTML]="data.text"></p>
  </mat-dialog-content>
  <div style="display: flex;flex-direction:row-reverse;">
    <div style="margin-top:auto">
      <button mat-button data-cy="no" (click)="no()">Nej</button>
      <button mat-button data-cy="yes"(click)="yes()">Ja</button>
    </div>
  </div>
</div>
